import React from "react";
import {
  Receipt,
  Mail,
  CalendarCog,
  Users,
  ShieldCheck,
  Boxes,
  Settings2,
  type LucideIcon,
} from "lucide-react";

/**
 * Presentational metadata (icon per section) kept out of the pure-data config.
 * Falls back to a generic settings icon so new sections render without edits.
 */
const SECTION_ICON: Record<string, LucideIcon> = {
  reimbursement: Receipt,
  leave: Mail,
  leavePolicy: CalendarCog,
  employee: Users,
  asset: Boxes,
  liriadmin: ShieldCheck,
};

export const getSectionIcon = (key: string): LucideIcon =>
  SECTION_ICON[key] ?? Settings2;

export const SectionIcon: React.FC<{ sectionKey: string; className?: string }> = ({
  sectionKey,
  className,
}) => {
  const Icon = getSectionIcon(sectionKey);
  return <Icon className={className} aria-hidden="true" />;
};
